// extracted by css-extract-rspack-plugin
export default {"Box_0":"BlankState-module__Box_0__uCjPJRE","Box_1":"BlankState-module__Box_1__LKvwQSQ","Box_2":"BlankState-module__Box_2__fd4Avs7","Box_3":"BlankState-module__Box_3__J9t7TD6"};